interface Props {
  onToggle: () => void;
  isOpen: boolean;
  children: React.ReactNode;
  header: string;
}

export const HintsAccordionItem = ({
  onToggle,
  isOpen,
  children,
  header,
}: Props) => {
  return (
    <div className="border-t last:border-b border-foreground/90 overflow-hidden">
      <button
        onClick={() => onToggle()}
        className="w-full flex justify-between items-center text-left focus:outline-none gap-4 py-4"
      >
        <span className="font-semibold text-xl text-foreground/90">
          {header}
        </span>
        {isOpen ? (
          <svg
            className="size-8 min-w-8"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <path
              d="M20 16H12M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            className="size-8 min-w-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 12V20M20 16H12M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </button>
      {isOpen && <div className="pb-4 text-foreground/80">{children}</div>}
    </div>
  );
};
